import React, { useContext } from "react"
import { Button, Stack, More, Modal } from "components/kit"
import { context as localeContext } from "context/locale"
import * as translations from "constants/translations"
import { breadcrumbs } from "constants/translations"
import { Breadcrumbs } from "components/common/dashboard"
import { Text, Link } from "components/service"
import { getBackUrl } from "utils/history"
import * as paths from "paths.js"
import cx from "classnames"
import DeleteModal from "./DeleteModal"

export default ({ paymentCredentialsId, storeId, isSubmitting }) => {
  const { lang, direction } = useContext(localeContext)
  return (
    <Modal>
      {({ open, close }) => (
        <div
          className={cx(
            "pb-6 flex flex-wrap items-center",
            lang === "ar" ? "-mr-3 flex-row-reverse" : "-ml-3"
          )}
        >
          <Breadcrumbs
            links={[paths.setup, paths.paymentGateways]}
            path={breadcrumbs.SETUP_EDIT_PAYMENT_METHODS}
          />
          <Stack
            className={cx(
              lang === "ar" ? "mr-auto flex-row-reverse" : "ml-auto"
            )}
            direction="wrap"
            expandItem={false}
            spacing="2"
          >
            <Button kind="primary" isSpinning={isSubmitting}>
              <Text value={translations.SAVE_CHANGE} />
            </Button>
            <Link omitQuery to={getBackUrl() || paths.paymentGateways}>
              <Button type="button" kind="secondary">
                <Text value={translations.CANCEL} />
              </Button>
            </Link>
            <More
              items={[
                {
                  title: <Text value={translations.DELETE} />,
                  onClick: () =>
                    open({
                      title: (
                        <Text value={translations.DELETED_PAYMENT_GATEWAY} />
                      ),
                      body: (
                        <DeleteModal
                          id={paymentCredentialsId}
                          storeId={storeId}
                          onClose={close}
                        />
                      ),
                      size: "max-w-md",
                    }),
                },
              ]}
            />
          </Stack>
        </div>
      )}
    </Modal>
  )
}
